let enquirySubmitted = false;
let isSubmitting = false;
function activateEnquiry(contactFrom) {
  const form = document.querySelector(".contact-form");
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    let hasError = false;

    let message = "";

    const name = document.querySelector(
      '.contact-form input[name="parents_name"]',
    );
    const mobile = document.querySelector('.contact-form input[name="mobile"]');
    const child = document.querySelector(
      '.contact-form input[name="child_name"]',
    );
    const kidssize = document.querySelector(".contact-form .kids-select");
    const adultssize = document.querySelector(".contact-form .adults-select");

    const preferredDate = document.querySelector("#preferredDate").value;
    const preferredTime = document.querySelector("#preferredTime").value;
    const additionalDate1 = document.querySelector("#additionalDate1").value;
    const additionalTime1 = document.querySelector("#additionalTime1").value;
    const additionalDate2 = document.querySelector("#additionalDate2").value;
    const additionalTime2 = document.querySelector("#additionalTime2").value;

    const error = document.querySelector(".contact-form .error");
    const submit = document.querySelector(".contact-btn");

    const preferredDateTime = `${formatDate(preferredDate)}, ${preferredTime}`;

    const additionalDateTime1 =
      additionalDate1 && additionalTime1
        ? `${formatDate(additionalDate1)}, ${additionalTime1}`
        : "";

    const additionalDateTime2 =
      additionalDate2 && additionalTime2
        ? `${formatDate(additionalDate2)}, ${additionalTime2}`
        : "";

    const today = new Date();
    today.setHours(0, 0, 0, 0); // normalize to start of day

    const prefDateObj = new Date(preferredDate);
    const addDate1Obj = additionalDate1 ? new Date(additionalDate1) : null;
    const addDate2Obj = additionalDate2 ? new Date(additionalDate2) : null;

    const selectedDates = [
      preferredDate,
      additionalDate1,
      additionalDate2,
    ].filter((date) => date !== "");

    const uniqueDates = new Set(selectedDates);

    if (name.value.trim() === "") {
      message = "Please enter the parent's name.";
      hasError = true;
    } else if (mobile.value.trim() === "") {
      message = "Please enter a mobile number.";
      hasError = true;
    } else if (!/^\d{10}$/.test(mobile.value.trim())) {
      message = "Please enter a valid 10-digit mobile number.";
      hasError = true;
    } else if (kidssize.value === "") {
      message = "Please select the number of kids.";
      hasError = true;
    } else if (adultssize.value === "") {
      message = "Please select the number of adults.";
      hasError = true;
    } else if (preferredDate === "") {
      message = "Please select preferred date.";
      hasError = true;
    } else if (preferredTime === "") {
      message = "Please select preferred time.";
      hasError = true;
    } else if (additionalDate1 && !additionalTime1) {
      message = "Please select time for additional date 1.";
      hasError = true;
    } else if (!additionalDate1 && additionalTime1) {
      message = "Please select date for additional time 1.";
      hasError = true;
    } else if (additionalDate2 && !additionalTime2) {
      message = "Please select time for additional date 2.";
      hasError = true;
    } else if (!additionalDate2 && additionalTime2) {
      message = "Please select date for additional time 2.";
      hasError = true;
    } else if (prefDateObj < today) {
      message = "Preferred date cannot be in the past.";
      hasError = true;
    } else if (addDate1Obj && addDate1Obj < today) {
      message = "Additional date 1 cannot be in the past.";
      hasError = true;
    } else if (addDate2Obj && addDate2Obj < today) {
      message = "Additional date 2 cannot be in the past.";
      hasError = true;
    } else if (selectedDates.length !== uniqueDates.size) {
      message = "Please select different dates for all options.";
      hasError = true;
    }

    if (hasError) {
      error.textContent = message;
      error.style.display = "block";
      return;
    }

    var data = $(".contact-form").serializeArray();
    data.push({ name: "contact_from", value: contactFrom });
    data.push({
      name: "preferred_datetime",
      value: preferredDateTime,
    });
    data.push({
      name: "additional_datetime_1",
      value: additionalDateTime1,
    });
    data.push({
      name: "additional_datetime_2",
      value: additionalDateTime2,
    });

    // console.log("Form Data:", data);

    isSubmitting = true;
    submit.disabled = true;

    $.ajax({
      url: "https://www.alivenow.in/getintouch_birthdayparty.php",
      type: "POST",
      data: data,
      success: onSuccess,
      error: onError,
    });

    function onSuccess() {
      let time = setTimeout(() => {
        error.style.display = "none";
        var newDiv = $(
          "<h1>Submitted successfully! <br>We&rsquo;ll get back to you soon. </h1>",
        ).addClass("thankyou");
        $("#thanku").after(newDiv);
        $(".tickmiddle").addClass("visible");
        $(".tickmiddle").css("display", "flex");
        $("form").css("display", "none");
      }, 650);
      enquirySubmitted = true;
      isSubmitting = false;

      submit.disabled = false;
      error.textContent = "";
      error.classList.toggle("success", true);
      error.style.display = "block";
      form.reset();
    }

    function onError(xhr, status, errorThrown) {
      // console.log("XHR:", xhr);
      // console.log("STATUS:", status);
      // console.log("ERROR:", errorThrown);
      // console.log("RESPONSE:", xhr.responseText);

      isSubmitting = false;

      submit.disabled = false;

      error.textContent =
        "An error occurred while submitting the form. Please try again.";

      error.classList.toggle("success", false);
      error.style.display = "block";
    }
  });
}

function formatDate(date) {
  if (!date) return "";

  const dt = new Date(date);

  if (isNaN(dt)) return "";

  return dt.toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
export { activateEnquiry };
